import { useTranslation } from 'react-i18next';
import { APP_LINKS } from '@/helpers/links';
import { MyLink } from '@scramble/ui';
import { DashboardBonusCard } from '../DashboardBonusCard';
import Icon from '@scramble/design-system/icons/percent-03.svg';

export const TopUpNoFeeCard = () => {
  const { t } = useTranslation();
  return (
    <DashboardBonusCard
      title={t('dashboard:offer_top_up_no_fee.title')}
      text={t('dashboard:offer_top_up_no_fee.text')}
      icon={<img src={Icon} alt="icon" width={24} height={24} />}
      footer={
        <MyLink href={APP_LINKS.addFunds}>
          {t('dashboard:offer_top_up_no_fee.link')}
        </MyLink>
      }
    />
  );
};
